// extracted by mini-css-extract-plugin
module.exports = {"ldsDualRing":"LoadingSpinner_ldsDualRing__RcJ_O","primary":"LoadingSpinner_primary__78i8L","secondary":"LoadingSpinner_secondary__qd_CW","white":"LoadingSpinner_white__PBVP_"};